import ResponseTemplate from './ResponseTemplate.js'

/**
 * @class
 * @implements ResponseTemplate
 */
export default class DraftResponseTemplate extends ResponseTemplate {
  /**
   * @method
   * @return {Array<Object, Object>}
   */

  getCochesDraft = () => [
    {
      id: 0,
      body: [
        {id: 0, name: 'Coches / 4x4', selected: true},
        {id: 1, name: 'Furgonetas'}
      ],
      color: [
        {id: 0, name: 'Blanco', selected: true},
        {id: 1, name: 'Azul'},
        {id: 2, name: 'Negro'}
      ],
      comments: 'Lorem ipsum dolor sit atmet',
      fuel: [
        {id: 0, name: 'Diesel'},
        {id: 1, name: 'Gasolina', selected: true},
        {id: 2, name: 'Eléctrico'}
      ],
      images: [
        {id: 0, name: 'Image url 1'},
        {id: 1, name: 'Image url 2', selected: true},
        {id: 2, name: 'Image url 3'}
      ],
      make: [
        {id: 0, name: 'Seat'},
        {id: 1, name: 'Audi', selected: true},
        {id: 2, name: 'Mercedes Benz'}
      ],
      km: '3213',
      model: [
        {id: 0, name: 'Ibiza', selected: true},
        {id: 1, name: 'León'},
        {id: 2, name: 'Toledo'}
      ],
      phone: '666666666',
      price: '123123',
      province: [
        {id: 0, name: 'Barcelona'},
        {id: 1, name: 'Tarragona', selected: true},
        {id: 2, name: 'Lleida'},
        {id: 3, name: 'Girona'}
      ],
      publishInVibbo: true,
      section1Id: 0,
      section2Id: 0,
      section3Id: 0,
      gearbox: [
        {id: 0, name: 'Manual', selected: true},
        {id: 1, name: 'Automática'},
        {id: 2, name: 'Semi-automática'}
      ],
      userId: 0,
      version: [
        {id: 0, name: 'Version 1', selected: true},
        {id: 1, name: 'Version 2'},
        {id: 2, name: 'Version 3'}
      ],
      year: [
        {id: 0, name: '2000', selected: true},
        {id: 1, name: '2001'},
        {id: 2, name: '2002'},
        {id: 3, name: '2003'}
      ],
      zipCode: '5678'
    }
  ]

  getMotosDraft = () => [
    {
      id: 0,
      body: [
        {id: 0, name: 'Motocicletas', selected: true},
        {id: 1, name: 'Accesorios'},
        {id: 2, name: 'Clásicas y cometiciñon'},
        {id: 3, name: 'Buggy'},
        {id: 4, name: 'Mini motos'}
      ],
      color: [
        {id: 0, name: 'Blanco', selected: true},
        {id: 1, name: 'Azul'},
        {id: 2, name: 'Negro'}
      ],
      comments: 'Lorem ipsum dolor sit atmet',
      fuel: [
        {id: 0, name: 'Gasolina', selected: true},
        {id: 1, name: 'Eléctrica'}
      ],
      images: [
        {id: 0, name: 'Image url 1'},
        {id: 1, name: 'Image url 2', selected: true},
        {id: 2, name: 'Image url 3'}
      ],
      make: [
        {id: 0, name: 'Honda'},
        {id: 1, name: 'Kawasaki', selected: true},
        {id: 2, name: 'BMW'},
        {id: 3, name: 'Yamaha'},
        {id: 4, name: 'Montesa'},
        {id: 5, name: 'Gas gas'}
      ],
      km: '3213',
      model: [
        {id: 0, name: 'CBR', selected: true},
        {id: 1, name: 'FZR'},
        {id: 2, name: 'Africa twin'}
      ],
      phone: '666666666',
      price: '123123',
      province: [
        {id: 0, name: 'Barcelona'},
        {id: 1, name: 'Tarragona', selected: true},
        {id: 2, name: 'Lleida'},
        {id: 3, name: 'Girona'}
      ],
      publishInVibbo: true,
      section1Id: 0,
      section2Id: 0,
      section3Id: 0,
      gearbox: [
        {id: 0, name: 'Manual', selected: true},
        {id: 1, name: 'Automática'}
      ],
      userId: 0,
      version: [
        {id: 0, name: '600', selected: true},
        {id: 1, name: '900'},
        {id: 2, name: '1000'},
        {id: 2, name: '1200'},
        {id: 3, name: '1600'}
      ],
      year: [
        {id: 0, name: '2000', selected: true},
        {id: 1, name: '2001'},
        {id: 2, name: '2002'},
        {id: 3, name: '2003'}
      ],
      zipCode: '5678'
    }
  ]

  build({appName}) {
    const response = appName === 'COCHES' ? this.getCochesDraft() : this.getMotosDraft()
    return response
  }
}
